
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { compose } from 'redux'
import { translate } from 'react-i18next'
import { withStyles } from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import CircularProgress from '@material-ui/core/CircularProgress'
import { find } from 'lodash'
import SessionIdInput from './SessionIdInput'
import DecisionSelect from './DecisionSelect'

const styles = theme => ({
  buttonProgress: {...theme.button.progress},
  fullWidth: {width: '100%'},
  hidden: {visibility: 'hidden'},
  highEmphasis: {color: theme.typography.highEmphasis},
  mediumEmphasis: {color: theme.typography.mediumEmphasis},
  root: {flexGrow: 1},
  well: {
    padding: '12px',
    backgroundColor: '#f5f5f5',
    border: '1px solid #e3e3e3',
    borderRadius: '0px',
    boxShadow: 'inset 0 1px 1px rgba(0,0,0,.05)',
  }
})

export class InitiateSessionForm extends Component {
  constructor(props) {
    super(props)
    this.state = {
      caseId: '',
      caseIdPrefix: '',
      caseIdSuffix: '',
      compositeCaseId: '', // prefix + caseId + suffix
      decisionId: '',
      containsSpecialChar: false
    }
    this.decisionKeys = Object.keys(props.availableDecisions)
  }

  componentDidMount() {
    window.addEventListener('focus', this.onFocus)
  }

  componentWillUnmount() {
    window.removeEventListener('focus', this.onFocus)
  }

  onFocus = () => {
    if (this.state.decisionId && this.state.caseId.length) {
      this.handleDecisionChange()
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if(prevState.caseId !== this.state.caseId) {
      const {caseId, caseIdPrefix, caseIdSuffix} = this.state
      const compositeCaseId = `${caseIdPrefix}${caseId}${caseIdSuffix}`
      this.setState({compositeCaseId})
    }
  }

  getDecision(decisionId) {
    let decision
    const {availableDecisions} = this.props
    for(let k in availableDecisions) {
      const decisions = availableDecisions[k]
      decision = find(decisions, d => d.id.toString() === decisionId)
      if(decision) break
    }
    return decision
  }

  handleCaseIdChange = (caseId, containsSpecialChar) => {
    this.setState({ caseId, containsSpecialChar }, () => {
      if (!containsSpecialChar) this.props.onChange('caseId', this.state)
    })
  }

  handleDecisionChange = (event) => {
    const decisionId = event ? event.target.value : this.state.decisionId
    /*  nextCaseId is an api suggested caseId based on decision. If absent, it will be empty string.
        When decision changes we always populate input with nextCaseId. If empty string we consider
        isSuggestedCaseId to be false.  */
    const {nextCaseId, prefix: caseIdPrefix, suffix: caseIdSuffix} = this.getDecision(decisionId)
    this.setState({
      caseId: nextCaseId.toString(),
      caseIdPrefix,
      caseIdSuffix,
      decisionId
    }, () => {
        this.props.onChange('decisionId', this.state)
        if(this.caseIdInputRef)
          this.caseIdInputRef.focus()
      }
    )
  }

  render() {
    const {availableDecisions, classes, errors, isRequestingInitialization, onSubmit, t, isValidating} = this.props
    const {caseId, compositeCaseId, decisionId, caseIdSuffix, caseIdPrefix, containsSpecialChar } = this.state
    const { decisionKeys } = this

    return (
      <div className={classes.root}>
        <Grid
          alignContent="space-around"
          container
          justify="center"
          spacing={24}
        >
          <Grid item xs={10}>
            <Typography variant="subheading">
              <span className={classes.highEmphasis} style={{display: 'block'}}>
                {t('To Start A New Session')}
              </span>
              <span className={classes.mediumEmphasis}>
                {t('Decisions Are Grouped By Domain')}
              </span>
            </Typography>
          </Grid>
          {!!decisionKeys.length ? (
            <React.Fragment>
              <Grid item xs={10}>
                <DecisionSelect
                  decisions={availableDecisions}
                  onChange={this.handleDecisionChange}
                />
              </Grid>
              <Grid item xs={10}>
                <SessionIdInput
                  caseId={caseId}
                  decisionId={decisionId}
                  isValidating={isValidating}
                  caseIdPrefix={caseIdPrefix}
                  caseIdSuffix={caseIdSuffix}
                  visible={!!decisionId}
                  errors={errors}
                  onChange={this.handleCaseIdChange}
                />
              </Grid>
              <Grid item xs={10}>
                <Button
                  className={`${classes.fullWidth}`}
                  color="primary"
                  disabled={(errors.caseIdUniqueness || !caseId.length || containsSpecialChar) || isValidating}
                  onClick={() => onSubmit(compositeCaseId, decisionId)}
                  variant="contained"
                >
                  {t('Initiate Session')}
                  {isRequestingInitialization && (
                    <CircularProgress
                      className={classes.buttonProgress}
                      size={24}
                    />
                  )}
                </Button>
              </Grid>
            </React.Fragment>
          ) : (
            <Grid item xs={10}>
              <div className={classes.well}>
                <Typography variant="body2" align="center">
                  {t('No Decisions Found')}
                </Typography>
              </div>
          </Grid>
          )}
        </Grid>
      </div>
    )
  }
}

InitiateSessionForm.propTypes = {
  availableDecisions: PropTypes.objectOf(
    PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.string
      })
    )
  ).isRequired,
  errors: PropTypes.object,
  isValidating: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired
}

export default compose(
  translate(),
  withStyles(styles)
)(InitiateSessionForm)



// WEBPACK FOOTER //
// ./src/components/setup/InitiateSessionForm.js